import Vue from 'vue'

export default function (consumer, type, id, item) {
  const updateVersions = (id, versions) => {
    const toUpdate = versions.filter(version => !version.remove && (typeof version.source === 'object'))
    let promise = Promise.resolve()
    toUpdate.forEach(version => {
      promise = promise.then(() =>
        Vue.api.package(consumer, type, id).version(version.name).put(version.source)
          .then(() => true)
      )
    })
    return promise
  }
  const removeVersions = (id, versions) => {
    const toRemove = versions.filter(version => version.remove && version.existed)
    let promise = Promise.resolve()
    return toRemove.forEach(version => {
      promise = promise.then(() =>
        Vue.api.package(consumer, type, id).version(version.name).delete()
          .then(() => true)
      )
    })
  }
  id = id || item.id
  let versions = item.versions
  let isRepo = item.isRepo
  if (!id) return Promise.reject(new Error('Id is not set for this package'))
  if (!item.owner) return Promise.reject(new Error('Owner is not set for this package'))

  item.preview = item.preview.filter(preview => preview.length > 0)
  delete item.id
  delete item.isRepo
  delete item.version
  if (isRepo) {
    item.versions = versions.filter(v => !v.remove).map(v => v.name)
  } else {
    item.versions = item.versions.map(version => version.name)
    delete item.repository
  }
  return Vue.api.packages().put(consumer, type, id, item)
    .then(data => {
      if (!isRepo) {
        return updateVersions(data.id, versions)
          .then(() => removeVersions(data.id, versions))
          .then(() => data.package)
      }
      return data.package
    })
}
